angular
	.module 'App.Module.Adyen', []
	.config ($stateProvider) ->
		$stateProvider
			.state 'adyen_callback',
				url: '/adyen/callback'
				views:
					main:
						controller: ($state) ->
							$state.go('settings.account')
